import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      {/* Hero */}
      <section className="bg-navy text-white noise-overlay py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-gray-400 hover:text-bronze mb-6 transition-colors"
          >
            <ArrowLeft className="mr-2 w-4 h-4" />
            Back to Home
          </Link>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold">
            Terms of Service
          </h1>
          <p className="font-body text-gray-400 mt-4">
            Last updated: December 2024
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-bone py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm prose max-w-none">
            <h2 className="font-heading text-2xl text-navy">Agreement to Terms</h2>
            <p className="font-body text-gray-600">
              By accessing and using the DA TAXGUY & ASSOCIATES website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Services Description</h2>
            <p className="font-body text-gray-600">
              DA TAXGUY & ASSOCIATES provides tax preparation, bookkeeping, and accounting services. The specific scope of services will be outlined in an engagement letter or service agreement provided to clients.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Disclaimer of Tax Advice</h2>
            <p className="font-body text-gray-600">
              <strong>Information on this website is for general informational purposes only and does not constitute legal, tax, or financial advice.</strong> Every individual's tax situation is unique, and results vary based on individual circumstances. You should consult with a qualified professional regarding your specific situation.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">No Guarantee of Results</h2>
            <p className="font-body text-gray-600">
              While we strive to provide accurate and effective services, we cannot guarantee specific outcomes, refund amounts, or tax savings. Tax law is complex and subject to change, and results depend on numerous factors specific to each client.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Client Responsibilities</h2>
            <p className="font-body text-gray-600">
              Clients are responsible for:
            </p>
            <ul className="font-body text-gray-600">
              <li>Providing accurate and complete information</li>
              <li>Responding to requests for information in a timely manner</li>
              <li>Reviewing returns and documents before signing</li>
              <li>Using the secure portal for sensitive documents</li>
              <li>Keeping copies of all tax documents</li>
            </ul>

            <h2 className="font-heading text-2xl text-navy mt-8">Confidentiality</h2>
            <p className="font-body text-gray-600">
              We maintain the confidentiality of all client information in accordance with professional standards and applicable law. We will not disclose your information to third parties except as required by law or as necessary to provide our services.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Payment Terms</h2>
            <p className="font-body text-gray-600">
              Payment terms will be specified in your engagement letter or at the time of service. We reserve the right to withhold completed returns until payment is received.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Limitation of Liability</h2>
            <p className="font-body text-gray-600">
              To the fullest extent permitted by law, DA TAXGUY & ASSOCIATES shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services or website.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Intellectual Property</h2>
            <p className="font-body text-gray-600">
              All content on this website, including text, graphics, logos, and software, is the property of DA TAXGUY & ASSOCIATES and is protected by copyright and other intellectual property laws.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Changes to Terms</h2>
            <p className="font-body text-gray-600">
              We may update these Terms of Service from time to time. We will notify you of any material changes by posting the new terms on this page.
            </p>

            <h2 className="font-heading text-2xl text-navy mt-8">Contact Information</h2>
            <p className="font-body text-gray-600">
              Questions about these Terms of Service should be directed to:
            </p>
            <p className="font-body text-gray-600">
              Email: INFO@DATAXGUY.COM<br />
              Phone: 201-253-7674
            </p>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <Button
                asChild
                variant="outline"
                className="rounded-full"
              >
                <Link to="/contact">
                  Contact Us With Questions
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
